import { render, staticRenderFns } from "./FormChangeCoverageAreaRO.vue?vue&type=template&id=3bb622ff&scoped=true&"
import script from "./FormChangeCoverageAreaRO.vue?vue&type=script&lang=js&"
export * from "./FormChangeCoverageAreaRO.vue?vue&type=script&lang=js&"
import style0 from "./FormChangeCoverageAreaRO.vue?vue&type=style&index=0&id=3bb622ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb622ff",
  null
  
)

export default component.exports